<template>
  <div class="wrapper">
    <div class="animated fadeIn ">
      <b-row>
        <b-col cols="12">
         <b-breadcrumb :items="breadcrumbs"/>         
          <b-card header-tag="header" footer-tag="footer" style=" margin-bottom: 0px;">         
            <b-row class="boxto">  
              <!-- {{ shipmentcount }} -->
                <b-col sm="6" lg="2" style="cursor: pointer;">
                <b-card no-body class="bg-def" >
                  <b-card-body class="pb-0">          
                    <router-link
                        tag="li"
                        :to="{
                          name: 'quickdetails',
                          query: { keyword: shipmentname.Pending_allocation },
                        }"
                      >  <h4 class="mb-0 display-3 text-center" v-b-tooltip.hover title="Pending allocation " id="pickuppending">{{ shipmentcount.Pending_allocation || 0 }} </h4>
                     <p class="text-center countcolor" v-b-tooltip.hover title="Pending allocation ">Pending allocation </p>
                    </router-link>
                  </b-card-body>        
                </b-card>
              </b-col>
               <b-col sm="6" lg="2" style="cursor: pointer;">
                <b-card no-body class="bg-green">
                  <b-card-body class="pb-0">          
                    <router-link
                        tag="li"
                        :to="{
                          name: 'quickdetails',
                          query: { keyword: shipmentname.Pending_ofd },
                        }"
                      >   
                      <h4  class="mb-0 display-3 text-center" id="totalrto" v-b-tooltip.hover title="Pending OFD">{{ shipmentcount.Pending_ofd || 0 }} </h4>
                     <p class="text-center countcolor" v-b-tooltip.hover title="Pending OFD">Pending OFD </p>
                    </router-link>
                  </b-card-body>        
                </b-card>
              </b-col>
                <b-col sm="6" lg="2" style="cursor: pointer;">
                <b-card no-body class="bg-purpal">
                  <b-card-body class="pb-0">          
                    <router-link
                        tag="li"
                        :to="{
                          name: 'quickdetails',
                          query: { keyword: shipmentname.Pending_delivery },
                        }"
                      >   
                    <h4  class="mb-0 display-3 text-center" id="delivered" v-b-tooltip.hover title="Pending Delivery">{{ shipmentcount.Pending_delivery || 0 }} </h4>
                     <p class="text-center countcolor" v-b-tooltip.hover title="Pending Delivery">Pending Delivery</p>
                    </router-link>
                  </b-card-body>        
                </b-card>
              </b-col> 

               <b-col sm="6" lg="2" style="cursor: pointer;">
                <b-card no-body class="bg-pink">
                  <b-card-body class="pb-0">          
                    <router-link
                        tag="li"
                        :to="{
                          name: 'quickdetails',
                          query: { keyword: shipmentname.Pending_ndr_handover },
                        }"
                      >   
                    <h4  class="mb-0 display-3 text-center" id="pickupassigned" v-b-tooltip.hover title="Pending NDR Handover">{{ shipmentcount.Pending_ndr_handover || 0 }} </h4>
                    <p class="text-center countcolor"  v-b-tooltip.hover title="Pending NDR Handover">Pending NDR Handover</p>
                    </router-link>
                  </b-card-body>        
                </b-card>
              </b-col>


              <b-col sm="6" lg="2" style="cursor: pointer;">
                <b-card no-body class="bg-aqua">
                  <b-card-body class="pb-0">          
                    <router-link
                        tag="li"
                        :to="{
                          name: 'quickdetails',
                          query: { keyword: shipmentname.Pending_rto },
                        }"
                      >   
                    <h4  class="mb-0 display-3 text-center" id="pickupassigned" v-b-tooltip.hover title="Pending RTO">{{ shipmentcount.Pending_rto || 0 }} </h4>
                    <p class="text-center countcolor"  v-b-tooltip.hover title="Pending RTO">Pending RTO</p>
                    </router-link>
                  </b-card-body>        
                </b-card>
              </b-col>
              
                
              <b-col sm="6" lg="2" style="cursor: pointer;">
                <b-card no-body class="bg-pink">
                  <b-card-body class="pb-0">          
                    <router-link
                        tag="li"
                        :to="{
                          name: 'quickdetails',
                          query: { keyword: shipmentname.Pending_rvp_allocation },
                        }"
                      >   
                    <h4  class="mb-0 display-3 text-center" id="deliverypending" v-b-tooltip.hover title="Pending RVP allocation">{{ shipmentcount.Pending_rvp_allocation || 0 }} </h4>
                     <p class="text-center countcolor"  v-b-tooltip.hover title="Pending RVP allocation">Pending RVP allocation</p>
                    </router-link>
                  </b-card-body>        
                </b-card>
              </b-col>
              <b-col sm="6" lg="2" style="cursor: pointer;">
                <b-card no-body class="bg-purpal">
                  <b-card-body class="pb-0">          
                    <router-link
                        tag="li"
                        :to="{
                          name: 'quickdetails',
                          query: { keyword: shipmentname.Pending_ofp },
                        }"
                      >   
                    <h4  class="mb-0 display-3 text-center" id="delivered" v-b-tooltip.hover title="Pending OFP ">{{ shipmentcount.Pending_ofp || 0 }} </h4>
                     <p class="text-center countcolor" v-b-tooltip.hover title="Pending OFP ">Pending OFP </p>
                    </router-link>
                  </b-card-body>        
                </b-card>
              </b-col>
             
              <b-col sm="6" lg="2" style="cursor: pointer;">
                <b-card no-body class="bg-red">
                  <b-card-body class="pb-0" >          
                    <router-link
                        tag="li"
                        :to="{
                          name: 'quickdetails',
                          query: { keyword: shipmentname.Pending_pickup },
                        }"
                      >   
                    <h4  class="mb-0 display-3 text-center" id="ndr" v-b-tooltip.hover title=" Pending Pic Up ">{{ shipmentcount.Pending_pickup || 0 }} </h4>
                     <p class="text-center countcolor" v-b-tooltip.hover title=" Pending Pic Up "> Pending Pic Up </p>
                    </router-link>
                  </b-card-body>        
                </b-card>
              </b-col>

               <b-col sm="6" lg="2" style="cursor: pointer;">
                <b-card no-body class="bg-pink">
                  <b-card-body class="pb-0">          
                    <router-link
                        tag="li"
                        :to="{
                          name: 'quickdetails',
                          query: { keyword: shipmentname.Pending_rvp_handover },
                        }"
                      >   
                    <h4  class="mb-0 display-3 text-center" id="pickupassigned" v-b-tooltip.hover title="Pending RVP handover ">{{ shipmentcount.Pending_rvp_handover || 0 }} </h4>
                    <p class="text-center countcolor"  v-b-tooltip.hover title="Pending RVP handover ">Pending RVP handover </p>
                    </router-link>
                  </b-card-body>        
                </b-card>
              </b-col>
              <b-col sm="6" lg="2" style="cursor: pointer;">
                <b-card no-body class="bg-aqua">
                  <b-card-body class="pb-0">          
                    <router-link
                        tag="li"
                        :to="{
                          name: 'quickdetails',
                          query: { keyword: shipmentname.Pending_cod_handover },
                        }"
                      >   
                    <h4  class="mb-0 display-3 text-center" id="pickupassigned" v-b-tooltip.hover title="Pending COD Handover ">{{ shipmentcount.Pending_cod_handover || 0 }} </h4>
                    <p class="text-center countcolor"  v-b-tooltip.hover title="Pending COD Handover ">Pending COD Handover </p>
                    </router-link>
                  </b-card-body>        
                </b-card>
              </b-col>
            </b-row>
           
          </b-card>
          <hr />

          <b-card header-tag="header" footer-tag="footer" style=" margin-bottom: 0px;">         
            <b-row class="boxto">  
               <b-col sm="6" lg="2" style="cursor: pointer;">
                <b-card no-body class="bg-pink">
                  <b-card-body class="pb-0">          
                    <router-link
                        tag="li"
                        :to="{
                          name: 'quickdetails',
                          query: { keyword: shipmentname.total_allocated },
                        }"
                      >   
                    <h4  class="mb-0 display-3 text-center" id="pickupassigned" v-b-tooltip.hover title="Total Allocated ">{{ shipmentcount.total_allocated || 0 }} </h4>
                    <p class="text-center countcolor"  v-b-tooltip.hover title="Total Allocated ">Total Allocated </p>
                    </router-link>
                  </b-card-body>        
                </b-card>
              </b-col>
              <b-col sm="6" lg="2" style="cursor: pointer;">
                <b-card no-body class="bg-aqua">
                  <b-card-body class="pb-0">          
                    <router-link
                        tag="li"
                        :to="{
                          name: 'quickdetails',
                          query: { keyword: shipmentname.total_delivered },
                        }"
                      >   
                    <h4  class="mb-0 display-3 text-center" id="pickupassigned" v-b-tooltip.hover title="Total Deliverd">{{ shipmentcount.total_delivered || 0 }} </h4>
                    <p class="text-center countcolor"  v-b-tooltip.hover title="Total Deliverd">Total Deliverd</p>
                    </router-link>
                  </b-card-body>        
                </b-card>
              </b-col>
              <b-col sm="6" lg="2" style="cursor: pointer;">
                <b-card no-body class="bg-def" >
                  <b-card-body class="pb-0">          
                    <router-link
                        tag="li"
                        :to="{
                          name: 'quickdetails',
                          query: { keyword: shipmentname.total_ndr },
                        }"
                      >   
                    <h4  class="mb-0 display-3 text-center" v-b-tooltip.hover title="Total NDR" id="pickuppending">{{ shipmentcount.total_ndr || 0 }} </h4>
                     <p class="text-center countcolor" v-b-tooltip.hover title="Total NDR">Total NDR</p>
                    </router-link>
                  </b-card-body>        
                </b-card>
              </b-col>
               <b-col sm="6" lg="2" style="cursor: pointer;">
                <b-card no-body class="bg-green">
                  <b-card-body class="pb-0">          
                    <router-link
                        tag="li"
                        :to="{
                          name: 'quickdetails',
                          query: { keyword: shipmentname.total_rto },
                        }"
                      >   
                    <h4  class="mb-0 display-3 text-center" id="totalrto" v-b-tooltip.hover title="Total RTO">{{ shipmentcount.total_rto || 0 }} </h4>
                     <p class="text-center countcolor" v-b-tooltip.hover title="Total RTO">Total RTO </p>
                    </router-link>
                  </b-card-body>        
                </b-card>
              </b-col>   
              <b-col sm="6" lg="2" style="cursor: pointer;">
                <b-card no-body class="bg-pink">
                  <b-card-body class="pb-0">          
                    <router-link
                        tag="li"
                        :to="{
                          name: 'quickdetails',
                          query: { keyword: shipmentname.total_ofd },
                        }"
                      >   
                    <h4  class="mb-0 display-3 text-center" id="deliverypending" v-b-tooltip.hover title="Total OFD">{{ shipmentcount.total_ofd || 0 }} </h4>
                     <p class="text-center countcolor"  v-b-tooltip.hover title="Total OFD">Total OFD</p>
                    </router-link>
                  </b-card-body>        
                </b-card>
              </b-col>
              <b-col sm="6" lg="2" style="cursor: pointer;">
                <b-card no-body class="bg-purpal">
                  <b-card-body class="pb-0">          
                    <router-link
                        tag="li"
                        :to="{
                          name: 'quickdetails',
                          query: { keyword: shipmentname.total_rvp_allocation },
                        }"
                      >   
                    <h4  class="mb-0 display-3 text-center" id="delivered" v-b-tooltip.hover title="Total RVP Allocated">{{ shipmentcount.total_rvp_allocation || 0 }} </h4>
                     <p class="text-center countcolor" v-b-tooltip.hover title="Total RVP Allocated">Total RVP Allocated</p>
                    </router-link>
                  </b-card-body>        
                </b-card>
              </b-col>
             
              <b-col sm="6" lg="2" style="cursor: pointer;">
                <b-card no-body class="bg-red">
                  <b-card-body class="pb-0" >          
                    <router-link
                        tag="li"
                        :to="{
                          name: 'quickdetails',
                          query: { keyword: shipmentname.total_rvp_pickup },
                        }"
                      >   
                    <h4  class="mb-0 display-3 text-center" id="ndr" v-b-tooltip.hover title="RVP PIC UP ">{{ shipmentcount.total_rvp_pickup || 0 }} </h4>
                     <p class="text-center countcolor" v-b-tooltip.hover title="RVP PIC UP ">RVP PIC UP </p>
                    </router-link>
                  </b-card-body>        
                </b-card>
              </b-col>
              <b-col sm="6" lg="2" style="cursor: pointer;">
                <b-card no-body class="bg-green">
                  <b-card-body class="pb-0">          
                    <router-link
                        tag="li"
                        :to="{
                          name: 'quickdetails',
                          query: { keyword: shipmentname.total_rvp_cancalled },
                        }"
                      >   
                      <h4  class="mb-0 display-3 text-center" id="totalrto" v-b-tooltip.hover title="RVP cancelled">{{ shipmentcount.total_rvp_cancalled || 0 }} </h4>
                     <p class="text-center countcolor" v-b-tooltip.hover title="RVP cancelled">RVP cancelled </p>
                    </router-link>
                  </b-card-body>        
                </b-card>
              </b-col>   
              <b-col sm="6" lg="2" style="cursor: pointer;">
                <b-card no-body class="bg-pink">
                  <b-card-body class="pb-0">          
                    <router-link
                        tag="li"
                        :to="{
                          name: 'quickdetails',
                          query: { keyword: shipmentname.total_rvp_handover },
                        }"
                      >   
                      <h4  class="mb-0 display-3 text-center" id="deliverypending" v-b-tooltip.hover title="RVP Handover ">{{ shipmentcount.total_rvp_handover || 0 }} </h4>
                     <p class="text-center countcolor"  v-b-tooltip.hover title="RVP Handover ">RVP Handover </p>
                    </router-link>
                  </b-card-body>        
                </b-card>
              </b-col>

            </b-row>
           
          </b-card>

          <hr />

          <b-card header-tag="header" footer-tag="footer" style=" margin-bottom: 0px;">         
            <b-row class="boxto"> 
              <b-col sm="6" lg="4" style="cursor: pointer;">
                <b-card no-body class="bg-purpal">
                  <b-card-body class="pb-0">          
                    <router-link
                        tag="li"
                        :to="{
                          name: 'quickdetails',
                          query: { keyword: shipmentname.total_cod_collected },
                        }"
                      >   
                    <h4  class="mb-0 display-3 text-center" id="delivered" v-b-tooltip.hover title="Total COD collected">{{ shipmentcount.total_cod_collected || 0 }} </h4>
                     <p class="text-center countcolor" v-b-tooltip.hover title="Total COD collected">Total COD collected</p>
                    </router-link>
                  </b-card-body>        
                </b-card>
              </b-col>
             
              <b-col sm="6" lg="4" style="cursor: pointer;">
                <b-card no-body class="bg-red">
                  <b-card-body class="pb-0" >          
                    <router-link
                        tag="li"
                        :to="{
                          name: 'quickdetails',
                          query: { keyword: shipmentname.total_cod_handover },
                        }"
                      >   
                    <h4  class="mb-0 display-3 text-center" id="ndr" v-b-tooltip.hover title="Total packed ">{{ shipmentcount.total_cod_handover || 0 }} </h4>
                     <p class="text-center countcolor" v-b-tooltip.hover title="Total packed ">Total COD handover</p>
                    </router-link>
                  </b-card-body>        
                </b-card>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
  </div>
</div>
</template>
<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import auth from "@/utils/auth";

export default {
  data: function () {
    return {
      name: 'dashboard',
       breadcrumbs: [{
        text: 'Quick Adv Dashboard',
        active: true
      }],
      pickuplocationmasterid:'',
      shipmentcount:{},
      shipmentname:{},
    }
  },
  components: {
   
    userInfo: []
  },
  created: function () {
    this.qwikadvdashboardshipments()
  },
  methods: {
    
    qwikadvdashboardshipments(){
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      this.pickuplocationmasterid = userInfo.pickuplocationmasterid;
           const obj = {
          hub_id: `${userInfo.pickuplocationmasterid}`,
        };

        this.$http
          .post(
            `${CONSTANTS.MIGRATION_API_URL}/qwikadvdashboardshipments`,
            obj
          )
          .then((result) => {
            if(result.body.returnmsg == 'Successful'){
             
            this.shipmentcount = result.body.returnvalue.reduce((obj, item) => {
              obj[item.shipment_status] = item.shipment_count;
              return obj;
            }, {});

            this.shipmentname = result.body.returnvalue.reduce((obj, item) => {
              obj[item.shipment_status] = item.shipment_status;
              return obj;
            }, {});
            
            console.log("shipmentcount", this.shipmentcount)

            }
            else{
              this.shipmentcount = []
            }
          })
        
    }
  }
};
</script>

<style>
.bg-aqua{
      background-color: #00c0ef !important;
      color: #fff!important;
}
.bg-green{
      background-color: #00a65a !important;
       color: #fff!important;
}
.bg-yellow{
      background-color: #f39c12 !important;
       color: #fff!important;
}
.bg-pink{
  background-color: #FF69B4 !important;
   color: #fff!important;
}
.bg-purpal{  
    background-color: #9370DB !important;
     color: #fff!important;
}
.bg-cyan{
      background-color: #008B8B !important;
       color: #fff!important;  
}
.bg-red{
      background-color: #dd4b39 !important;
       color: #fff!important;
}
.bg-def{
  background-color: #f09642 !important;
   color: #fff!important;
  
}
.boxto .card-body{
  padding: 0px!important;
}
.countcolor
{
      color:white !important;

}
.display-3 
{
      font-size: 3.5rem !important;
}

</style>